export const DRAWER_WIDTH = 236;
export const TOAST_TIME_OUT = 4000;
export const EMPTY_DATA = "N/A";
export const MAX_LAST_DAY_ALLOW = 30;

export const API_STATUS = {
  SUCCESS: 200,
  INVALID_REQUEST: 400,
  NOT_FOUND: 404,
  UNAUTHORIZED: 401,
  INTERNAL_SERVER: 500,
};

export const API_ERROR_MSG = {
  BAD_REQUEST: "Something isn't quite right. Please try again later.",
  INTERNAL_SERVER_MSG:
    "An internal server error occurred. Please try again later.",
  INVALID_TOKEN: "Session expired. Please log back in to continue.",
};

export const LOCAL_MSG = {
  INVALID_IMAGE_FORMAT: "Invalid Image format!",
  USER_PROFILE_UPDATED: "Your profile has been updated successfully.",
  USER_DETAIL_UPDATED: "User details have been updated successfully.",
  FAMRER_PROFILE_UPDATED: "Farmer profile has been updated successfully.",
  FARMER_INSPECTION_UPDATED: "Inspection  have been updated successfully.",
  FARMER_HARVESTING_UPDATED:
    "Harvesting details have been updated successfully.",
  FERMENTATION_UPDATED: "Fermentation details have been updated successfully.",
  CHEMISTRY_UPDATED: "Chemistry log details have been updated successfully.",
  WASTE_WATER_UPDATED: "Waste water details have been updated successfully.",
  STRIPING_UPDATED: "Stripping data have been updated successfully.",
  SPIRIT_UPDATED: "Spirit log have been updated successfully.",
  SPIRIT_LOG_DELETED: "Spirit log has been deleted successfully.",
  PROOFING_UPDATED: "Proofing details have been updated successfully.",
  CASK_AND_AGING_UPDATED: "Cask And Aging has been updated successfully.",
  SAMPLING_UPDATED: "Sampling log details have been updated successfully.",
  BOTTLING_UPDATED: "Details has been updated successfully.",
  SUPPLIER_UPDATE: "Supplier Details has been updated successfully.",
  MOLASSES_UPDATE: "Molasses Details has been updated successfully.",
  CASK_MASTER_UPDATED: "Cask Details has been updated successfully.",
  CANE_VARIETY_UPDATED: "Cane Variety has been updated successfully.",
};

export const IMG_PROFILE = {
  ASPECT_RATIO: 1,
  MIN_WIDTH_HEIGHT: 50,
};

export const DROP_DOWN = {
  USER: "user",
  FERMENTATION: "fermentation",
  PROOFING: "proofing",
  CASK_MASTER: "caskmaster",
  CASK_AGING: "caskaging",
  COUNTRY: "country",
  SUPPLIER: "supplier",
};

export const DROP_DOWN_PROCESS = {
  FERMENTATION: "fermentation",
  STRIPPING_PROCESS: "stripping",
  SPIRIT_PROCESS: "spirit",
  PROOFING: "proofing",
};

export const COLLECTION_TYPE = [
  { label: "Foreshots", value: "Foreshots" },
  { label: "Heads", value: "Heads" },
  { label: "Hearts", value: "Hearts" },
  { label: "Tails", value: "Tails" },
];

export const COUNTRY_OPTIONS = [
  { label: "United States", value: "us" },
  { label: "Dominica", value: "dominica" },
  {label:'Canada',value:'canada'},
];

export const RUM_BATCH_TYPE = [
  { label: "Juice Single Barrel Aged", value: "Juice Single Barrel Aged" },
  { label: "Juice Barrel Strength Aged", value: "Juice Barrel Strength Aged" },
  { label: "Juice Blended Rum", value: "Juice Blended Rum" },
  {
    label: "Molasses Single Barrel Aged",
    value: "Molasses Single Barrel Aged",
  },
  {
    label: "Molasses Barrel Strength Aged",
    value: "Molasses Barrel Strength Aged",
  },
  { label: "Molasses Blended Rum", value: "Molasses Blended Rum" },
];

export const RUM_TYPE = [
  { label: "White / Silver", value: "White / Silver" },
  { label: "Gold / Oro", value: "Gold / Oro" },
  { label: "Dark / Black", value: "Dark / Black" },
  { label: "Aged / Añejo", value: "Aged / Añejo" },
  { label: "Spiced", value: "Spiced" },
  { label: "Overproof", value: "Overproof" },
  { label: "Agricultural / Rhum Agricole", value: "Agricultural / Rhum Agricole" },
  { label: "Cachaça", value: "Cachaça" },
  { label: "Flavoured", value: "Flavoured" }
];

export const PRIOR_FILL_TYPE = [
  { label: "None", value: "None" },
  { label: "Bourbon", value: "Bourbon" },
  { label: "Sherry", value: "Sherry" },
  { label: "Wine (Red)", value: "Wine (Red)" },
  { label: "Wine (White)", value: "Wine (White)" },
  { label: "Whiskey", value: "Whiskey" },
  { label: "Scotch", value: "Scotch" },
  { label: "Rum", value: "Rum" },
  { label: "Brandy", value: "Brandy" },
  { label: "Tequila", value: "Tequila" },
  { label: "Beer", value: "Beer" },
  {label: "Calvados", value: "Calvados"},
];

// Remove Code to next Realse
export const TANK_NUMBER = [{ label: "No data found", value: null }];

export const QUALITY = {
  GRADE_A: "Grade A",
};

export const CANE_VARIETY = [
  {
    label: "Please add a new variety to the Cane Variety section.",
    value: null,
  },
];
